import { type ReactNode, useEffect } from "react";
import { CommunityVariantProvider } from "@/src/common/components/product-demo/community-variant-context";

export function AppThemeProvider({ children }: { children: ReactNode }) {
	useEffect(() => {
		const root = document.documentElement;
		root.classList.remove("dark");
		root.classList.add("light");
		root.setAttribute("data-theme", "light");
	}, []);

	return <CommunityVariantProvider>{children}</CommunityVariantProvider>;
}
